module.exports = __webpack_public_path__ + "img/1122x748_theologie.79ae9589.jpg";